










import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class Flex extends Vue {
  @Prop({ type: String, default: '' }) readonly justifyContent?: string
  @Prop({ type: String, default: '' }) readonly alignItems?: string
  @Prop({ type: String, default: '' }) readonly pointerEvents?: string
  @Prop({ type: Boolean, default: false }) readonly mobile?: boolean
}
